exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkout[data-v-7f68efb2]{max-width:1840px}.checkout .tooltip[data-v-7f68efb2]{width:12px;height:12px;border-radius:50%;font-size:8px;display:inline-flex;justify-content:center;align-items:center;color:#fff;margin-left:4px;cursor:default;background-color:#23b32f}", ""]);

// exports
